import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';
import { canManageAdminHierarchy } from '../lib/permissions';

export default function DefaultOfferSettings(){
  const {workspace,role}=useAuth();
  const isSuperAdmin=canManageAdminHierarchy(role);
  const [code,setCode]=useState('CORE_997');
  const [name,setName]=useState('Core Offer');
  const [price,setPrice]=useState('997');
  const [loading,setLoading]=useState(true);
  const [saving,setSaving]=useState(false);
  const [error,setError]=useState('');
  const [message,setMessage]=useState('');

  useEffect(()=>{
    if(!isSuperAdmin||!workspace?.id){setLoading(false);return;}
    let cancelled=false;
    (async()=>{
      setLoading(true);setError('');
      const {data,error:loadError}=await supabase.rpc('get_default_offer_setting',{p_workspace_id:workspace.id});
      if(cancelled)return;
      setLoading(false);
      if(loadError){setError(loadError.message||'Could not load the default offer.');return;}
      const row=data?.[0];
      if(row?.offer_id){setCode(row.code||'');setName(row.name||'');setPrice(String(row.price??''));}
    })();
    return()=>{cancelled=true};
  },[isSuperAdmin,workspace?.id]);

  if(!isSuperAdmin)return null;

  async function save(event){
    event.preventDefault();
    const numericPrice=Number(price);
    if(!code.trim()||!name.trim()){setError('Offer code and offer name are required.');return;}
    if(!Number.isFinite(numericPrice)||numericPrice<=0){setError('Offer price must be greater than zero.');return;}
    setSaving(true);setError('');setMessage('');
    const {data,error:saveError}=await supabase.rpc('save_default_offer_setting',{
      p_workspace_id:workspace.id,
      p_code:code.trim(),
      p_name:name.trim(),
      p_price:numericPrice,
    });
    setSaving(false);
    if(saveError){setError(saveError.message||'Could not save the default offer.');return;}
    const row=data?.[0];
    if(row){setCode(row.code||code.trim().toUpperCase());setName(row.name||name.trim());setPrice(String(row.price??numericPrice));}
    setMessage('Default offer saved. New sales cycles will use this offer.');
  }

  return <div className="panel data-settings-panel">
    <div className="panel-head"><div><span className="settings-eyebrow">Sales configuration</span><h2>Default offer</h2><p className="small-note">Used automatically when a new Lead and Sales Cycle are created.</p></div><span className="settings-status-badge neutral">Super Admin only</span></div>
    {error&&<div className="error-message">{error}</div>}
    {message&&<div className="success-message">{message}</div>}
    {loading?<div className="compact-empty">Loading default offer…</div>:<form onSubmit={save} className="default-offer-settings-form">
      <div className="lead-source-grid">
        <div><label className="field-label" htmlFor="defaultOfferName">Offer name</label><input id="defaultOfferName" className="text-input" value={name} onChange={e=>setName(e.target.value)} placeholder="Core Offer" /></div>
        <div><label className="field-label" htmlFor="defaultOfferCode">Offer code</label><input id="defaultOfferCode" className="text-input" value={code} onChange={e=>setCode(e.target.value.toUpperCase())} placeholder="CORE_997" autoCapitalize="characters" /></div>
        <div><label className="field-label" htmlFor="defaultOfferPrice">Price</label><input id="defaultOfferPrice" className="text-input" type="number" min="0.01" step="0.01" value={price} onChange={e=>setPrice(e.target.value)} placeholder="997" /></div>
      </div>
      <div className="settings-inline-actions"><button className="primary-button no-margin" disabled={saving}>{saving?'Saving…':'Save default offer'}</button></div>
    </form>}
  </div>;
}
